const destinations = [
  { flag: "🇫🇷", country: "France", city: "Paris & Nice", desc: "Mandeville's deep connection to Louisiana's French heritage makes Paris the top international destination for Northshore professionals and families. Alsace and Bordeaux wine country tours are popular.", popular: true },
  { flag: "🇮🇹", country: "Italy", city: "Rome, Florence & Amalfi", desc: "Mediterranean cruises departing from Barcelona or Civitavecchia bring Mandeville families to Italy. The Amalfi Coast and Cinque Terre are especially popular with Northshore travelers.", popular: true },
  { flag: "🇬🇧", country: "United Kingdom", city: "London", desc: "Legal conferences at the Inns of Court, medical CME events at RCPCH, and business meetings in the City of London attract Mandeville professionals with regularity.", popular: true },
  { flag: "🇯🇵", country: "Japan", city: "Tokyo & Kyoto", desc: "Cultural tourism in Japan has surged among affluent Northshore families and retirees. Tokyo, Kyoto, and Hiroshima itineraries are increasingly popular for Mandeville travelers.", popular: false },
  { flag: "🇬🇷", country: "Greece", city: "Athens & Santorini", desc: "Greek island cruises and Aegean sea journeys are among the most-requested destinations for Mandeville retirees and anniversary travelers. Santorini sunset views are iconic.", popular: false },
  { flag: "🇨🇷", country: "Costa Rica", city: "San José & Guanacaste", desc: "Eco-tourism and adventure travel are growing among younger Mandeville professionals and families with children. Costa Rica's safe reputation makes it a top family pick.", popular: false },
];

export default function MandevilleDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Where Mandeville Travels</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Top International Destinations from Mandeville
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From European professional conferences to Mediterranean cruises and Japanese cultural tours, here are the most common international destinations for Mandeville and Northshore travelers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {destinations.map((d, i) => (
            <div key={i} className={`rounded-lg border p-5 flex flex-col hover:border-[#F6C344] transition-all ${d.popular ? "bg-[#F7F8FA] border-gray-200" : "bg-white border-gray-200"}`}>
              <div className="flex items-center gap-3 mb-3">
                <span className="text-3xl">{d.flag}</span>
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{d.city}</p>
                  <p className="text-gray-400 text-xs">{d.country}</p>
                </div>
                {d.popular && <span className="ml-auto text-xs font-bold text-[#F6C344] bg-[#F6C344]/10 px-2 py-0.5 rounded-full whitespace-nowrap">Top Pick</span>}
              </div>
              <p className="text-gray-500 text-sm leading-relaxed flex-1">{d.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}